let HomeMenu = document.createElement("div");
HomeMenu.classList.add('home-menu');

HomeMenu.innerHTML = `
<a href="/#/about" class="about-link">About Yantras</a>
<a href="/#/howto">How to Meditate with Yantras</a>
`
export default HomeMenu;
